<div cdkDrag cdkDragBoundary=".cdk-overlay-container"
     cdkDragRootElement=".dialog-box.dsgvo">
  <div cdkDragHandle mat-dialog-title>
    <h1>{{ globals.titles.dsgvo }}</h1>
    <app-close-button [data]="closeData"></app-close-button>
  </div>
  <div class="root" mat-dialog-content>
    <strong>Datenschutzerklärung</strong>
    <p>Wir informieren Sie nachfolgend gemäß den gesetzlichen Vorgaben des Datenschutzrechts (insb. gemäß BDSG n.F.
      und
      der europäischen Datenschutz-Grundverordnung ‚DS-GVO‘) über die Art, den Umfang und Zweck der Verarbeitung
      personenbezogener Daten durch unser Unternehmen. Diese Datenschutzerklärung gilt auch für unsere Websites und
      Sozial-Media-Profile. Bezüglich der Definition von Begriffen wie etwa „personenbezogene Daten“ oder
      „Verarbeitung“
      verweisen wir auf Art. 4 DS-GVO.</p>
    <strong>Name und Kontaktdaten des / der Verantwortlichen</strong><br/>
    Unser/e Verantwortliche/r (nachfolgend „Verantwortlicher“) i.S.d. Art. 4 Zif. 7 DS-GVO ist:<br/>
    <br/>Andreas Perlitz<br/>Karlsbader Str. 15<br/>86169 Augsburg Deutschland<br/>E-Mail-Adresse:
    nightscoutreporter&#64;gmail.com<br/><br/><strong>Datenarten, Zwecke der Verarbeitung und Kategorien betroffener
    Personen</strong><br/>
    <p>Nachfolgend informieren wir Sie über Art, Umfang und Zweck der Erhebung, Verarbeitung und Nutzung
      personenbezogener
      Daten.</p>
    <strong>1. Arten der Daten, die wir verarbeiten</strong><br/>Inhaltsdaten (Texteingaben, Videos, Fotos etc.),
    <br/>
    <br/>
    <strong>2. Zwecke der Verarbeitung nach Art. 13 Abs. 1 c) DS-GVO</strong><br/>Leichten Zugang zur Website
    ermöglichen,
    Website benutzerfreundlich gestalten, Websites mit Funktionen und Inhalten bereitstellen, <br/>
    <br/>
    <strong>3. Kategorien der betroffenen Personen nach Art. 13 Abs. 1 e) DS-GVO</strong><br/>Besucher/Nutzer der
    Website,
    <br/>
    <br/>
    <p>Die betroffenen Personen werden zusammenfassend als „Nutzer“ bezeichnet.</p>
    <br/>

    <strong>Rechtsgrundlagen der Verarbeitung personenbezogener Daten</strong>
    <p>Nachfolgend Informieren wir Sie über die Rechtsgrundlagen der Verarbeitung personenbezogener Daten:</p>
    <ol style="margin:10px 0; padding:15px;">
      <li>Wenn wir Ihre Einwilligung für die Verarbeitung personenbezogenen Daten eingeholt haben, ist Art. 6 Abs. 1
        S. 1
        lit. a) DS-GVO Rechtsgrundlage.
      </li>
      <li>Ist die Verarbeitung zur Erfüllung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen
        erforderlich,
        die auf Ihre Anfrage hin erfolgen, so ist Art. 6 Abs. 1 S. 1 lit. b) DS-GVO Rechtsgrundlage.
      </li>
      <li>Ist die Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung erforderlich, der wir unterliegen (z.B.
        gesetzliche Aufbewahrungspflichten), so ist Art. 6 Abs. 1 S. 1 lit. c) DS-GVO Rechtsgrundlage.
      </li>
      <li>Ist die Verarbeitung erforderlich, um lebenswichtige Interessen der betroffenen Person oder einer anderen
        natürlichen Person zu schützen, so ist Art. 6 Abs. 1 S. 1 lit. d) DS-GVO Rechtsgrundlage.
      </li>
      <li>Ist die Verarbeitung zur Wahrung unserer oder der berechtigten Interessen eines Dritten erforderlich und
        überwiegen diesbezüglich Ihre Interessen oder Grundrechte und Grundfreiheiten nicht, so ist Art. 6 Abs. 1 S. 1
        lit. f) DS-GVO Rechtsgrundlage.
      </li>
    </ol>
    <br/>
    <strong>Weitergabe personenbezogener Daten an Dritte und Auftragsverarbeiter</strong>
    <p>Ohne Ihre Einwilligung geben wir grundsätzlich keine Daten an Dritte weiter. Sollte dies doch der Fall sein,
      dann
      erfolgt die Weitergabe auf der Grundlage der zuvor genannten Rechtsgrundlagen z.B. bei der Weitergabe von Daten
      an
      Online-Paymentanbieter zur Vertragserfüllung oder aufgrund gerichtlicher Anordnung oder wegen einer gesetzlichen
      Verpflichtung zur Herausgabe der Daten zum Zwecke der Strafverfolgung, zur Gefahrenabwehr oder zur Durchsetzung
      der
      Rechte am geistigen Eigentum.<br/>
      Wir setzen zudem Auftragsverarbeiter (externe Dienstleister z.B. zum Webhosting unserer Websites und
      Datenbanken)
      zur Verarbeitung Ihrer Daten ein. Wenn im Rahmen einer Vereinbarung zur Auftragsverarbeitung an die
      Auftragsverarbeiter Daten weitergegeben werden, erfolgt dies immer nach Art. 28 DS-GVO. Wir wählen dabei unsere
      Auftragsverarbeiter sorgfältig aus, kontrollieren diese regelmäßig und haben uns ein Weisungsrecht hinsichtlich
      der
      Daten einräumen lassen. Zudem müssen die Auftragsverarbeiter geeignete technische und organisatorische Maßnahmen
      getroffen haben und die Datenschutzvorschriften gem. BDSG n.F. und DS-GVO einhalten</p>

    <br/>
    <strong>Datenübermittlung in Drittstaaten</strong>
    <p>Durch die Verabschiedung der europäischen Datenschutz-Grundverordnung (DS-GVO) wurde eine einheitliche
      Grundlage
      für den Datenschutz in Europa geschaffen. Ihre Daten werden daher vorwiegend durch Unternehmen verarbeitet, für
      die
      DS-GVO Anwendung findet. Sollte doch die Verarbeitung durch Dienste Dritter außerhalb der Europäischen Union
      oder
      des Europäischen Wirtschaftsraums stattfinden, so müssen diese die besonderen Voraussetzungen der Art. 44 ff.
      DS-GVO
      erfüllen. Das bedeutet, die Verarbeitung erfolgt aufgrund besonderer Garantien, wie etwa die von der
      EU-Kommission
      offiziell anerkannte Feststellung eines der EU entsprechenden Datenschutzniveaus oder der Beachtung offiziell
      anerkannter spezieller vertraglicher Verpflichtungen, der so genannten „Standardvertragsklauseln“. Bei
      US-Unternehmen erfüllt die Unterwerfung unter das sog. „Privacy-Shield“, dem Datenschutzabkommen zwischen der EU
      und
      den USA, diese Voraussetzungen.</p>

    <br/>
    <strong>Löschung von Daten und Speicherdauer</strong>
    <p>Sofern nicht in dieser Datenschutzerklärung ausdrücklich angegeben, werden Ihre personenbezogen Daten gelöscht
      oder
      gesperrt, sobald der Zweck für die Speicherung entfällt, es sei denn deren weitere Aufbewahrung ist zu
      Beweiszwecken
      erforderlich oder dem stehen gesetzliche Aufbewahrungspflichten entgegenstehen. Darunter fallen etwa
      handelsrechtliche Aufbewahrungspflichten von Geschäftsbriefen nach § 257 Abs. 1 HGB (6 Jahre) sowie
      steuerrechtliche
      Aufbewahrungspflichten nach § 147 Abs. 1 AO von Belegen (10 Jahre). Wenn die vorgeschriebene Aufbewahrungsfrist
      abläuft, erfolgt eine Sperrung oder Löschung Ihrer Daten, es sei denn die Speicherung ist weiterhin für einen
      Vertragsabschluss oder zur Vertragserfüllung erforderlich.</p>

    <br/>
    <strong>Bestehen einer automatisierten Entscheidungsfindung</strong>
    <p>Wir setzen keine automatische Entscheidungsfindung oder ein Profiling ein.</p>

    <br/>
    <strong>Bereitstellung unserer Website und Erstellung von Logfiles</strong>
    <ol style="margin:10px 0; padding:15px;">
      <li>Wenn Sie unsere Webseite lediglich informatorisch nutzen (also keine Registrierung und auch keine
        anderweitige
        Übermittlung von Informationen), erheben wir nur die personenbezogenen Daten, die Ihr Browser an unseren
        Server
        übermittelt. Wenn Sie unsere Website betrachten möchten, erheben wir die folgenden Daten:
        • IP-Adresse;<br/>
        • Internet-Service-Provider des Nutzers;<br/>
        • Datum und Uhrzeit des Abrufs;<br/>
        • Browsertyp;<br/>
        • Sprache und Browser-Version;<br/>
        • Inhalt des Abrufs;<br/>
        • Zeitzone;<br/>
        • Zugriffsstatus/HTTP-Statuscode;<br/>
        • Datenmenge;<br/>
        • Websites, von denen die Anforderung kommt;<br/>
        • Betriebssystem.<br/>
        Eine Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten von Ihnen findet nicht
        statt.<br/><br/>
      </li>
      <li>Diese Daten dienen dem Zweck der nutzerfreundlichen, funktionsfähigen und sicheren Auslieferung unserer
        Website
        an Sie mit Funktionen und Inhalten sowie deren Optimierung und statistischen Auswertung.<br/><br/></li>
      <li>Rechtsgrundlage hierfür ist unser in den obigen Zwecken auch liegendes berechtigtes Interesse an der
        Datenverarbeitung nach Art. 6 Abs. 1 S.1 lit. f) DS-GVO.<br/><br/></li>
    </ol>
    <br/>
    <strong>Präsenz in sozialen Medien</strong>

    <ol style="margin:10px 0; padding:15px;">
      <li>Wir unterhalten in sozialen Medien Profile bzw. Fanpages, um mit den dort angeschlossenen und registrierten
        Nutzern zu kommunizieren und um über unsere Produkte, Angebote und Dienstleistungen zu informieren. Die
        US-Anbieter sind nach dem sog. Privacy-Shield zertifiziert und damit verpflichtet europäischen Datenschutz
        einzuhalten. Bei der Nutzung und dem Aufruf unseres Profils im jeweiligen Netzwerk durch Sie gelten die
        jeweiligen
        Datenschutzhinweise und Nutzungsbedingungen des jeweiligen Netzwerks.<br/><br/></li>
      <li>Wir verarbeiten Ihre Daten, die Sie uns über diese Netzwerke senden, um mit Ihnen zu kommunizieren und um
        Ihre
        dortigen Nachrichten zu beantworten.<br/><br/></li>
      <li>Die Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten ist unser berechtigtes Interesse an der
        Kommunikation mit den Nutzern und unsere Außendarstellung zwecks Werbung gemäß Art. 6 Abs. 1 S. 1 lit. f)
        DS-GVO.
        Soweit Sie dem Verantwortlichen des sozialen Netzwerks eine Einwilligung in die Verarbeitung Ihrer
        personenbezogenen Daten erteilt haben, ist Rechtsgrundlage Art. 6 Abs. 1 S. 1 lit. a) und Art. 7
        DS-GVO.<br/><br/>
      </li>
      <li>Die Datenschutzhinweise, Auskunftsmöglichkeiten und Widerspruchmöglichkeiten (Opt-Out) der jeweiligen
        Netzwerke
        finden Sie hier:<br/><br/>• <strong>Facebook</strong> (Facebook Ireland Ltd., 4 Grand Canal Square, Grand
        Canal
        Harbour, Dublin 2, Irland) Datenschutzerklärung: <a href="https://www.facebook.com/about/privacy/"
                                                            rel="nofollow"
                                                            target="_blank">https://www.facebook.com/about/privacy/</a>,
        Opt-Out: <a href="https://www.facebook.com/settings?tab=ads" rel="nofollow" target="_blank">https://www.facebook.com/settings?tab=ads</a>
        und <a href="http://www.youronlinechoices.com" rel="nofollow"
               target="_blank">http://www.youronlinechoices.com</a>,
        Privacy Shield: <a href="https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active"
                           rel="nofollow" target="_blank">https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active</a>.<br/><br/>•
        <strong>Google+</strong> (Google LLC, 1600 AmphitheatreParkway, Mountain View, CA 94043, USA) –
        Datenschutzerklärung: <a href="https://policies.google.com/privacy" rel="nofollow" target="_blank">https://policies.google.com/privacy</a>,
        Opt-Out: <a href="https://adssettings.google.com/authenticated" rel="nofollow" target="_blank">https://adssettings.google.com/authenticated</a>,
        Privacy Shield: <a href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active"
                           rel="nofollow" target="_blank">https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active</a>.<br/><br/>
      </li>
    </ol>
    <br/>
    <strong>Rechte der betroffenen Person</strong>

    <ol style="margin:10px 0; padding:15px;">
      <li><strong>Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten<br/><br/>
        Soweit die Verarbeitung auf Ihrer Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a), Art. 7 DS-GVO beruht, haben
        Sie
        das Recht, die Einwilligung jederzeit zu widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum
        Widerruf erfolgten Verarbeitung wird dadurch nicht berührt.<br/><br/>
        Soweit wir die Verarbeitung Ihrer personenbezogenen Daten auf die Interessenabwägung gemäß Art. 6 Abs. 1 S. 1
        lit.
        f) DS-GVO stützen, können Sie Widerspruch gegen die Verarbeitung einlegen. Dies ist der Fall, wenn die
        Verarbeitung insbesondere nicht zur Erfüllung eines Vertrags mit Ihnen erforderlich ist, was von uns jeweils
        bei
        der nachfolgenden Beschreibung der Funktionen dargestellt wird. Bei Ausübung eines solchen Widerspruchs bitten
        wir
        um Darlegung der Gründe, weshalb wir Ihre personenbezogenen Daten nicht wie von uns durchgeführt verarbeiten
        sollten. Im Falle Ihres begründeten Widerspruchs prüfen wir die Sachlage und werden entweder die
        Datenverarbeitung
        einstellen bzw. anpassen oder Ihnen unsere zwingenden schutzwürdigen Gründe aufzeigen, aufgrund derer wir die
        Verarbeitung fortführen.<br/><br/>
        Sie können der Verarbeitung Ihrer personenbezogenen Daten für Zwecke der Werbung und Datenanalyse jederzeit
        widersprechen. Das Widerspruchsrecht können Sie kostenfrei ausüben. Über Ihren Werbewiderspruch können Sie uns
        unter folgenden Kontaktdaten informieren:<br/><br/>Andreas Perlitz<br/>Karlsbader Str. 15<br/>86169 Augsburg
        Deutschland<br/>E-Mail-Adresse: nightscoutreporter&#64;gmail.com<br/></strong>
        <br/></li>
      <li><strong>Recht auf Auskunft</strong><br/>
        Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten
        verarbeitet werden. Sofern dies der Fall ist, haben Sie ein Recht auf Auskunft über Ihre bei uns gespeicherten
        persönlichen Daten nach Art. 15 DS-GVO. Dies beinhaltet insbesondere die Auskunft über die
        Verarbeitungszwecke,
        die Kategorie der personenbezogenen Daten, die Kategorien von Empfängern, gegenüber denen Ihre Daten
        offengelegt
        wurden oder werden, die geplante Speicherdauer, die Herkunft ihrer Daten, sofern diese nicht direkt bei Ihnen
        erhoben wurden.<br/><br/></li>
      <li><strong>Recht auf Berichtigung</strong><br/>
        Sie haben ein Recht auf Berichtigung unrichtiger oder auf Vervollständigung richtiger Daten nach Art. 16
        DS-GVO.
        <br/><br/>
      </li>
      <li><strong>Recht auf Löschung</strong><br/>
        Sie haben ein Recht auf Löschung Ihrer bei uns gespeicherten Daten nach Art. 17 DS-GVO, es sei denn
        gesetzliche
        oder vertraglichen Aufbewahrungsfristen oder andere gesetzliche Pflichten bzw. Rechte zur weiteren Speicherung
        stehen dieser entgegen.
        <br/><br/>
      </li>
      <li><strong>Recht auf Einschränkung</strong><br/>
        Sie haben das Recht, eine Einschränkung bei der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, wenn
        eine
        der Voraussetzungen in Art. 18 Abs. 1 lit. a) bis d) DS-GVO erfüllt ist:<br/>
        • Wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer bestreiten, die es dem
        Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen;<br/><br/>
        • die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten ablehnen und stattdessen
        die
        Einschränkung der Nutzung der personenbezogenen Daten verlangen;<br/><br/>
        • der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, Sie
        diese
        jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen, oder<br/><br/>
        • wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DS-GVO eingelegt haben und noch nicht
        feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber Ihren Gründen überwiegen.<br/><br/>
      </li>
      <li><strong>Recht auf Datenübertragbarkeit</strong><br/>
        Sie haben ein Recht auf Datenübertragbarkeit nach Art. 20 DS-GVO, was bedeutet, dass Sie die bei uns über Sie
        gespeicherten personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format erhalten
        können oder die Übermittlung an einen anderen Verantwortlichen verlangen können.
        <br/><br/>
      </li>
      <li><strong>Recht auf Beschwerde</strong><br/>
        Sie haben ein Recht auf Beschwerde bei einer Aufsichtsbehörde. In der Regel können Sie sich hierfür an die
        Aufsichtsbehörde insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts
        des
        mutmaßlichen Verstoßes wenden.
        <br/><br/>
      </li>
    </ol>
    <br/>
    <strong>Datensicherheit</strong>
    <p>Um alle personenbezogen Daten, die an uns übermittelt werden, zu schützen und um sicherzustellen, dass die
      Datenschutzvorschriften von uns, aber auch unseren externen Dienstleistern eingehalten werden, haben wir
      geeignete
      technische und organisatorische Sicherheitsmaßnahmen getroffen. Deshalb werden unter anderem alle Daten zwischen
      Ihrem Browser und unserem Server über eine sichere SSL-Verbindung verschlüsselt übertragen.</p>
    <br/>
    <br/>
    <strong>Stand: 16.10.2018</strong>
    <br/>
    <div class="source"><i>Quelle:</i> <a href="https://www.muster-vorlagen.net/datenschutzerklaerungs-generator/"
                                          target="_blank">Datenschutzerklärungs-Generator
      Muster-Vorlagen.net</a></div>
  </div>
  @if (false) {
    <mat-dialog-actions>
      <mat-checkbox class="check">Akzeptiert</mat-checkbox>
    </mat-dialog-actions>
  }
</div>
